(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["home-coord-studio"] && !Shopify.designMode) return;
  try {
    (() => {
    document.addEventListener('click', (event) => {
      const preview = event.target.closest?.('[data-studio-preview-entry]');
      if (!preview || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const button = preview.closest('.lf-studio-card')?.querySelector('.cslr-actions [data-csl-open]');
      if (!button) return;
      event.preventDefault();
      button.click();
    });
    const connection = navigator.connection;
    if (connection?.saveData || /^(slow-)?2g$/.test(connection?.effectiveType || '')) return;
    const root = () => document.querySelector('.lf-studio-card [data-coord-studio-launcher]');
    const entry = root();
    if (!entry) return;
    entry.querySelectorAll('[data-csl-piece] img').forEach((image) => {
      if (!image.getAttribute('src')) image.crossOrigin = 'anonymous';
    });
    const warmed = new Map();
    const attempted = new Set();
    const warm = (item) => {
      if (!item?.imageUrl || attempted.size >= 6 || attempted.has(item.imageUrl)) return;
      let url;
      try { url = new URL(item.imageUrl, location.origin); } catch { return; }
      if (url.protocol !== 'https:') return;
      attempted.add(item.imageUrl);
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      image.fetchPriority = 'low';
      image.src = url.href;
      warmed.set(item.imageUrl, image);
      image.decode().catch(() => warmed.delete(item.imageUrl));
    };
    const warmCard = (card) => {
      const title = card?.querySelector('.cse-product-copy strong')?.textContent?.trim();
      if (!title) return;
      const items = root()?.__coordStudioBootstrap?.library || [];
      const matches = items.filter((item) => item.title === title);
      if (matches.length === 1) warm(matches[0]);
    };
    const intent = (event) => {
      const card = event.target.closest?.('.cse-products-panel .cse-product-add');
      if (card) warmCard(card);
    };
    document.addEventListener('pointerover', intent, { passive: true });
    document.addEventListener('focusin', intent);
    let pending = null;
    document.addEventListener('click', (event) => {
      if (!event.target.closest?.('.lf-studio-card [data-csl-open]')) return;
      pending?.disconnect();
      const prepare = () => {
        if (!document.querySelector('.cse-app') || !root()?.__coordStudioBootstrap) return false;
        pending?.disconnect();
        pending = null;
        const firstPieces = () => {
          const cards = [...document.querySelectorAll('.cse-products-panel .cse-product-add')];
          cards.filter((card) => {
            const box = card.getBoundingClientRect();
            return box.width > 0 && box.height > 0 && box.top < innerHeight && box.bottom > 0;
          }).slice(0, 2).forEach(warmCard);
        };
        if ('requestIdleCallback' in window) requestIdleCallback(firstPieces, { timeout: 1200 });
        else setTimeout(firstPieces, 400);
        return true;
      };
      if (prepare()) return;
      const observer = new MutationObserver(prepare);
      pending = observer;
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => { observer.disconnect(); if (pending === observer) pending = null; }, 10000);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lfm-edition-library"] && !Shopify.designMode) return;
  try {
    (() => {
  function setup(root) {
    if (root.dataset.ready) return;
    const track = root.querySelector('.lfm-library__track');
    const cards = [...track.querySelectorAll('.lfm-story')];
    const previous = root.querySelector('[data-previous]');
    const next = root.querySelector('[data-next]');
    const position = root.querySelector('[data-position]');
    const filters = [...root.querySelectorAll('[data-filter]')];
    if (!cards.length) return;
    root.dataset.ready = 'true';
    root.querySelector('.lfm-library__controls').hidden = false;
    const visible = () => cards.filter(card => !card.hidden);
    function update() {
      const active = visible();
      const bounds = track.getBoundingClientRect();
      const inView = active.filter(card => {
        const box = card.getBoundingClientRect();
        return box.left >= bounds.left - 5 && box.right <= bounds.right + 5;
      });
      const first = inView[0] || active.find(card => card.getBoundingClientRect().right > bounds.left + 5);
      const last = inView[inView.length - 1] || first;
      const start = first ? active.indexOf(first) + 1 : 0;
      const end = last ? active.indexOf(last) + 1 : 0;
      position.textContent = `${start === end ? start : `${start}–${end}`} / ${active.length}`;
      previous.disabled = track.scrollLeft <= 5;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    function move(direction) {
      const active = visible();
      const stride = active.length > 1 ? active[1].offsetLeft - active[0].offsetLeft : track.clientWidth;
      const step = Math.max(1, Math.floor((track.clientWidth + 4) / stride));
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      track.scrollBy({left: direction * stride * step, behavior});
    }
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home' || event.key === 'End') track.scrollTo({left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'instant'});
      else move(event.key === 'ArrowRight' ? 1 : -1);
    });
    if (root.dataset.filterable === 'true') filters.forEach(filter => {
      const category = filter.dataset.filter;
      const count = cards.filter(card => category === 'all' || card.dataset.category === category).length;
      filter.querySelector('[data-filter-count]').textContent = count;
      filter.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        cards.forEach(card => { card.hidden = category !== 'all' && card.dataset.category !== category; });
        filters.forEach(link => {
          if (link === filter) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        track.scrollTo({left: 0, behavior: 'instant'});
        update();
      });
    });
    let timer;
    track.addEventListener('scroll', () => { clearTimeout(timer); timer = setTimeout(update, 100); }, {passive:true});
    new ResizeObserver(update).observe(track);
    update();
  }
  function init(scope) { scope.querySelectorAll('[data-lfm-library]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ouji-collection-knowledge"] && !Shopify.designMode) return;
  try {
    (() => {
  function revealOujiTarget(hash, focus) {
    if (!/^#ouji-/.test(hash)) return false;
    const target = document.getElementById(hash.slice(1));
    if (!target) return false;
    if (target.tagName === 'DETAILS') target.open = true;
    let parent = target.parentElement;
    while (parent) {
      if (parent.tagName === 'DETAILS') parent.open = true;
      parent = parent.parentElement;
    }
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({block: 'start', behavior: focus && !reducedMotion ? 'smooth' : 'instant'});
    if (focus) {
      const destination = target.matches('h2,h3,h4,summary') ? target : target.querySelector('summary,h2,h3,h4') || target;
      const temporaryTabIndex = !destination.hasAttribute('tabindex') && destination.tagName !== 'SUMMARY';
      if (temporaryTabIndex) {
        destination.setAttribute('tabindex', '-1');
        destination.addEventListener('blur', () => destination.removeAttribute('tabindex'), {once: true});
      }
      destination.focus({preventScroll: true});
    }
    return true;
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#ouji-"]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    if (!document.getElementById(link.hash.slice(1))) return;
    event.preventDefault();
    event.stopPropagation();
    if (window.location.hash !== link.hash) window.history.pushState(null, '', link.hash);
    revealOujiTarget(link.hash, true);
  }, true);
  const revealCurrentTarget = () => revealOujiTarget(window.location.hash, false);
  window.addEventListener('hashchange', revealCurrentTarget);
  window.addEventListener('popstate', revealCurrentTarget);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealCurrentTarget);
  else revealCurrentTarget();
})();
  } catch(e) { console.error(e); }
})();

})();
